import React from 'react';
import styled from 'libs/styled';

interface ContentGradientOverlayProps {
    enabled?: boolean;
    className?: string;
}

const filterTransientProps = { shouldForwardProp: (prop: string) => !prop.startsWith('$') };

/**
 * ContentGradient - A reusable gradient overlay component for content readability
 * Structure is prepared for fade overlay functionality
 * Full styling implementation can be added later when design is finalized
 */
const GradientOverlay = styled('div', filterTransientProps)<{ $enabled?: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        0deg,
        var(--gradient-30, rgba(23, 23, 23, 0.3)) 0%,
        var(--gradient-0, rgba(23, 23, 23, 0)) 110%
    );
    pointer-events: none;
    z-index: 1;
`;

const ContentGradientOverlay: React.FC<ContentGradientOverlayProps> = ({ enabled = true, className }) => (
    <GradientOverlay $enabled={enabled} className={className} />
);

export default ContentGradientOverlay;
